import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomePageComponent } from './home-page/home-page.component';
import { ContactPageComponent } from './contact-page/contact-page.component';
import { AboutPageComponent } from './about-page/about-page.component';
import { PlanManagementPageComponent } from './plan-management-page/plan-management-page.component';
import { ServiceAgreementPageComponent } from './service-agreement-page/service-agreement-page.component';
import { ServiceAgreementSentPageComponent } from './service-agreement-sent-page/service-agreement-sent-page.component';
import { PrivacyPageComponent } from './privacy-page/privacy-page.component';
import { ComplaintsPageComponent } from './complaints-page/complaints-page.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { ServerErrorPageComponent } from './server-error-page/server-error-page.component';
import { ComplaintSentPageComponent } from './complaint-sent-page/complaint-sent-page.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { EnquirySentComponent } from './enquiry-sent/enquiry-sent.component';
import { NotFoundComponent } from './not-found/not-found.component';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomePageComponent },
  { path: 'about', component: AboutPageComponent },
  { path: 'testimonials', component: TestimonialsComponent },
  { path: 'plan-management', component: PlanManagementPageComponent },
  { path: 'service-agreement-sent', component: ServiceAgreementSentPageComponent,},
  { path: 'service-agreement', component: ServiceAgreementPageComponent },
  { path: 'contact', component: ContactPageComponent },
  { path: 'enquiry-sent', component: EnquirySentComponent },
  { path: 'privacy-policy', component: PrivacyPageComponent },
  { path: 'make-a-complaint', component: ComplaintsPageComponent },
  { path: 'complaint-sent', component: ComplaintSentPageComponent },
  { path: 'terms-and-conditions', component: TermsAndConditionsComponent },
  { path: 'server-error', component: ServerErrorPageComponent },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    scrollPositionRestoration: 'top',
}),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
